import { ComputedRef, reactive, unref, watch } from '@vue/composition-api'

export const useCreateMicroViewProp = <T extends Record<string, any>>(valueRef: ComputedRef<T>) => {
  const reference = reactive<T>(unref(valueRef))
  const keys = Object.keys(reference as Record<string, any>)
  watch(
    keys.map((k) => () => (unref(valueRef) as any)[k]),
    (to) => {
      to.forEach((v, i) => {
        const k = keys[i]
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        reference[k] = v
      })
    }
  )
  return reference
}
